import axios from '@/apis/axios';

class IdType
{
    static async all()
    {
        const response = await axios.get('/api/id-types');
        
        return response.data.data;
    }
}

export default IdType;